import api from "./api";

/**
 * Requests Conta Azul OAuth authentication URL for a company.
 * Expects backend to accept: { companyId, clientId, clientSecret, nfeProvider }
 * and return either { url } or { authUrl } or plain string URL.
 */
export const getContaAzulAuthUrl = async ({
  companyId,
  clientId,
  clientSecret,
  nfeProvider,
}) => {
  const { data } = await api.post("/nfe/conta-azul/auth-url", {
    companyId,
    clientId,
    clientSecret,
    nfeProvider,
  });

  if (!data) return "";
  if (typeof data === "string") return data;
  return data.url || data.authUrl || "";
};
